<mat-expansion-panel #panel class="camera-panel" hideToggle [id]="id">
  <mat-expansion-panel-header
    collapsedHeight="64px"
    expandedHeight="64px"
    [ngClass]="{ active: isActive() }"
  >
    <ng-content [ngIf]="draggableList" select="#listDragHandle"></ng-content>
    <div class="camera-item fs-text-truncate">
      <div class="camera-list-item-d-flex camera-list-item-align-items-center">
        <sn-camera-record-status class="camera-record-status" size="xs" *ngIf="camera.isManaged" [record]="camera.record || camera.playbackUrls"></sn-camera-record-status>
        <span class="fs-text-truncate">{{ camera.name }}</span>
      </div>
      <div class="fs-text-secondary fs-text-truncate" *ngIf="camera.location">
        <span *ngIf="showLocation" class="show-location">{{ camera.location.name }}</span>
        <span *ngIf="camera.floor">({{ camera.floor.name }})</span>
      </div>
    </div>

    <sn-action-list alwaysCollapse [items]="actions" [context]="camera"></sn-action-list>
    <ng-content [ngIf]="draggableToMap" select="div.wrapper"></ng-content>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <sn-audit-camera-stream-view
      *ngIf="panel.expanded && camera.isLive"
      [@snFadeOutUp]
      [camera]="camera"
      [actions]="true"
    >
    </sn-audit-camera-stream-view>
  </ng-template>
</mat-expansion-panel>
